<template>
  <div class="mission-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Mission – Historique – Décret d’érection
      </h2>

      <!-- Mission -->
      <section class="content-section mb-8">
        <h3 class="section-title mb-4">MISSION</h3>
        <p class="mb-4">
          Messe d'ouverture et bénédiction de l'EITP, lundi 02 février 2018. 
          L’Évangile, quand il imprègne vraiment les cœurs et mentalités, provoque une véritable metanoia 
          personnelle et collective ; et fait éclore les diverses potentialités culturelles à la hauteur des divers enjeux.
        </p>
        <p class="mb-4">
          Les deux assemblées du synode spécial pour l’Afrique (1994 et 2009) ont rappelé l’urgence et la nécessité 
          de la formation chrétienne. Ecclesia in Africa, n° 54, lançait cette interrogation : 
          « L’Église en Afrique a-t-elle formé suffisamment les laïcs pour qu’ils assument leurs responsabilités civiques ? »
        </p>
        <p class="mb-4">
          Africӕ munus, n° 137, invitait à « une pastorale de l’intelligence et de la raison qui crée une habitude 
          de dialogue rationnel et d’analyse critique dans la société et dans l’Église ».
        </p>
        <p class="mb-4">
          Le pape François (visite “ad limina apostolorum”, 27 avril 2015) déclarait qu’« il est important que le désir 
          d’une connaissance profonde du mystère chrétien ne soit pas l’apanage d’une élite, mais anime tous les fidèles ».
        </p>

        <h4 class="section-subtitle mt-6 mb-3">Anniversaire de l’EITP – 02 Février 2020</h4>
        <p class="mb-4">
          Les Églises en Afrique peuvent offrir aux fidèles des outils capables de les aider à grandir dans la foi. 
          Le diocèse de Cotonou institue l’École d’Initiation Théologique et Pastorale pour une présentation rationnelle 
          et organique des trésors de la foi chrétienne et la constitution d’un laboratoire de dialogue avec la société.
        </p>
        <p class="mb-4">
          La mission de l’EITP est de former des chrétiens qui fassent de la théologie à partir des défis de la foi, 
          ancrée dans la vie de foi.
        </p>
      </section>

      <!-- Historique -->
      <section class="content-section mb-8">
        <h3 class="section-title mb-4">HISTORIQUE</h3>
        <p class="mb-4">
          Au regard des divers défis de la vie de foi et des recommandations d’Ecclesia in Africa et Africӕ munus, 
          un projet de Centre Culturel Catholique fut proposé par le Père Rodrigue Gbédjinou le 19 avril 2016 et exposé à son conseil le même jour.
        </p>
        <p class="mb-4">
          Le projet, réélaboré, fut présenté le 3 novembre 2016 à Mgr Roger Houngbédji qui donna ses vives appréciations. 
          Celui-ci fut assumé par le diocèse de Cotonou comme École d’Initiation Théologique et Pastorale, par le décret du 15 novembre 2017.
        </p>
      </section>

      <!-- Décret d'érection -->
      <section class="content-section">
        <h3 class="section-title mb-4">DÉCRET D’ÉRECTION</h3>
        <p class="mb-4">
          <a href="@/assets/documents/Decret_EITP.pdf" target="_blank" class="text-blue-600 underline">
            Télécharger le Décret
          </a>
        </p>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MissionHisto",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.mission-wrap {
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.section-title {
  color: #2b3a67;
  font-weight: 600;
}

.section-subtitle {
  color: #2b3a67;
  font-weight: 500;
  font-size: 1.1rem;
}

.content-section p {
  margin-bottom: 1rem;
}
</style>
